(function () {

  // ── STEP 1: Block ALL click events on +/- buttons inside quick-add-bulk
  // Using capture phase so we intercept BEFORE Dawn's listeners fire
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quantity__button');
    if (!btn) return;

    const quickAddBulk = btn.closest('quick-add-bulk');
    if (!quickAddBulk) return;

    // Stop Dawn's handler from ever seeing this click
    e.stopImmediatePropagation();

    // Do the math ourselves
    const input = quickAddBulk.querySelector('.quantity__input');
    if (!input) return;

    const current = parseInt(input.value, 10) || 0;
    const step    = parseInt(input.getAttribute('step') || 1, 10);
    const min     = parseInt(input.getAttribute('min')  || 0, 10);
    const max     = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;

    if (btn.name === 'plus') {
      input.value = Math.min(max, current + step);
    } else if (btn.name === 'minus') {
      input.value = Math.max(min, current - step);
    }

    // Trigger our sync
    input.dispatchEvent(new Event('input', { bubbles: true }));

  }, true); // <-- capture: true is the key


  // ── STEP 2: Also block 'change' and 'input' events on the qty input
  // Dawn's quick-order-list.js listens for these and calls cart API too
  document.addEventListener('change', function (e) {
    if (!e.target.closest('quick-add-bulk')) return;
    e.stopImmediatePropagation();
  }, true);


  // ── STEP 3: Per-card button logic ──────────────────────────────────────
  function initCard(el) {
    if (el._atcPatched) return;
    el._atcPatched = true;

    const variantId = el.dataset.index;
    const input     = el.querySelector('.quantity__input');
    const btn       = el.querySelector('.bulk-atc-btn');

    if (!input || !btn) return;

    let cartQty     = parseInt(input.dataset.cartQuantity || 0, 10);
    let userModified = false;

    function syncButton() {
      const qty = parseInt(input.value, 10) || 0;
      if (userModified && qty > 0) {
        btn.style.display = 'block';
        btn.textContent   = cartQty > 0 ? 'Update Cart' : 'Add to Cart';
      } else {
        btn.style.display = 'none';
      }
    }

    // Listen on our own input events (dispatched from Step 1 above)
    input.addEventListener('input', () => {
      userModified = true;
      syncButton();
    });

    // ── Add to Cart ──────────────────────────────────────────────────────
    btn.addEventListener('click', async () => {
      const qty = parseInt(input.value, 10);
      if (qty < 1) return;

      btn.disabled    = true;
      btn.textContent = 'Adding...';

      try {
        // Always add on top — never overwrite with change.js
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: qty }],
          }),
        });

        if (!res.ok) throw new Error('Cart request failed');

        // Refresh cart count bubble
        const updatedCart = await fetch('/cart.js').then((r) => r.json());
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach((el) => {
          el.textContent = updatedCart.item_count;
        });
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );

        // Reset input to 0 — next add will accumulate on top of cart
        cartQty                    = 0;
        userModified               = false;
        input.dataset.cartQuantity = 0;
        input.value                = 0;

        btn.textContent = '✓ Added!';
        setTimeout(() => {
          //btn.style.display = 'none';
          btn.textContent   = 'Add to Cart';
          btn.disabled      = false;
        }, 2000);

      } catch (err) {
        console.error('Bulk ATC error:', err);
        btn.textContent = 'Error — try again';
        btn.disabled    = false;
        setTimeout(() => { btn.textContent = 'Add to Cart'; }, 2000);
      }
    });

  }

  // ── STEP 4: Init all cards ─────────────────────────────────────────────
  function init() {
    document.querySelectorAll('quick-add-bulk').forEach(initCard);
  }

  document.addEventListener('DOMContentLoaded', init);
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });

})();